import {create} from 'zustand'
import { authSlice } from './authSlice'
import { siteSlice } from './siteSlice'
import {persist,devtools} from 'zustand/middleware'

let useStore = (...a) =>({
        ...authSlice(...a),
        ...siteSlice(...a),
    })

useStore = persist(useStore, {name:'eyeconx-store'})
useStore = devtools(useStore)

export const useEyeconxStore = create(useStore)